import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { forkJoin, Observable, of } from "rxjs";
import { ApresentacaoService } from "../services/apresentacao.service";

@Injectable({
  providedIn: 'root'
})
export class ApresentacaoResolver implements Resolve<boolean> {

  constructor(private service: ApresentacaoService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ApresentacaoCombosResolver{

  constructor(private service: ApresentacaoService) { }

  resolve(): Observable<any> {
    return this.service.getListCombos();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ApresentacaoResolverId {

  constructor(private service: ApresentacaoService) { }
  getById(id:number): Observable<any> {
    var storedData  = sessionStorage.getItem('dataMeeting' + id); 
    if (storedData) {
      return of(JSON.parse(storedData));
    } else {
      return new Observable((observer) => {
        forkJoin({
          filter: this.service.getListCombos(),
          data: this.service.getById(id),
          graph1: this.service.getGraphData(id, 1),
          graph2: this.service.getGraphData(id, 2),
          graph3: this.service.getGraphData(id, 3),
        }).subscribe({
          next: ({ filter, data, graph1, graph2, graph3 }) => {
            filter['agencies'] = [];
            var timers = {};
            var slide = 0;
            data.agencyPf = data?.agencyPf?.map(ag => {
              var agencyMany = ag?.tb_org_orgao_many;
              if(agencyMany && agencyMany.length >0){
                agencyMany = agencyMany.map(agm =>{
                  filter['agencies'].push({ 'id': agm.num_codigo_pk, 'label': agm.str_nome });
                  agm.project_full = agm.project_full.map(pf =>{
                    timers[agm.num_codigo_pk] = (pf.ac_meeting_pf_agency_child?.minutes ?? 30) * 60000;
                    var newPf = {...pf, slide: slide};
                    slide += pf.pf_indicator.length;
                    return newPf;
                  });
                  return agm
                })
              }
              else{
                console.log(filter['agencies'])
                filter['agencies'].push({ 'id': ag.num_codigo_pk, 'label': ag.str_nome });
                ag.project_full = ag.project_full.map(pf =>{
                  timers[ag.num_codigo_pk] = (pf.ac_meeting_pf_agency_child?.minutes ?? 0) * 60000;
                  var newPf = {...pf, slide: slide};
                  slide += pf.pf_indicator.length;
                  return newPf;
                });
              }
              return { ...ag, tb_org_orgao_many: agencyMany };
            })
            data.filter = filter;
            data.graphData = {...graph1, ...graph2, ...graph3};
            console.log({...graph1, ...graph2, ...graph3})
            data.timers = timers;
            data.baseTimers = timers;
            data.currentFilter = {
              agency_id: filter?.agencies.map(a => a.id),
              pf_ind_current_table_status: filter?.pfIndCurrentTable.map(a => a.id),
              pf_ind_analysis_stat_id: filter?.pfIndAnalysisStat.map(a => a.id),
              enabled: filter?.enabledOptions.map(a => a.id),
            }
            sessionStorage.clear();
            sessionStorage.setItem('dataMeeting' + id, JSON.stringify(data));
            observer.next(data);
            observer.complete();
          },
          error: (err) => {
            observer.error(err); 
          }
        });
      });
    }
  }
}